/**
 * 平台菜单 - 辅助管理
 */

export default [
  {
    label: 'menu.other001', //辅助功能
    icon: 'icon-tongjichaxun',
    path: '/other',
    permission: 'taxcloud7001',
    id:'7001',
    children: [
      {
        label: 'menu.other002', //销售管理
        icon: 'm-xiaoshouguanli',
        permission: 'taxcloud6070',
        id:'6070',
        path: '/collection',
        children: [
          {
            label: 'menu.other003', //对账单
            icon: 'icon-guyuan_gerenxinxi',
            path: '/income/income.action',
            permission: 'taxcloud6071',
            id:'6071'
          },
          {
            label: 'menu.other004', //发票申请
            icon: 'icon-guyuan_gerenxinxi',
            path: '/fapiao/bills_toCusBillInfo.action',
            permission: 'taxcloud6072',
            id:'6072'
          },
          {
            label: 'menu.other005', //客户管理
            icon: 'icon-guyuan_gerenxinxi',
            path: '/baseInfo/customManage.action',
            permission: 'taxcloud5045',
            id:'5045'
          },
          {
            label: 'menu.other006', //客户合同管理
            icon: 'icon-guyuan_gerenxinxi',
            path: '/contract/customerContractAction_toContractStatusListIndex.action',
            permission: 'taxcloud7102',
            id:'7102'
          },
          {
            label: 'menu.other007', //客户合同结束申请
            icon: 'icon-guyuan_gerenxinxi',
            path: '/contract/contract_toContractEndApplyStatusListIndex.action',
            permission: 'taxcloud7104',
            id:'7104',
            query: {
              contractType: 'Y3VzdG9tZXI-'
            }
          }
        ]
      },
      {
        label: 'menu.other008', //工资
        icon: 'm-gongzi',
        permission: 'taxcloud6085',
        id:'6085',
        path: '/salary/salaryCDetail.action',
      },
      {
        label: 'menu.other009', //印鉴申请
        icon: 'm-yinjianshenqing',
        permission: 'taxcloud8103',
        id:'8103',
        path: '/seal/sealApplicationAction_toSealApplyIndex.action',
      },
      // {
      //   label: '库存管理',
      //   icon: 'm-kucunguanli',
      //   permission: 'taxcloud8124',
      //   id:'8124',
      //   path: '/inventory',
      //   children: [
      //     {
      //       label: '库存列表',
      //       icon: 'icon-guyuan_gerenxinxi',
      //       path: '/inventory/inventoryAction_toStorageDetail.action',
      //       permission: 'taxcloud8125',
      //       id:'8125'
      //     },
      //     {
      //       label: '出入库明细',
      //       icon: 'icon-guyuan_gerenxinxi',
      //       path: '/inventory/inventoryAction_toBatchDetailList.action',
      //       permission: 'taxcloud8127',
      //       id:'8127'
      //     },
      //     {
      //       label: '出入库申请',
      //       icon: 'icon-guyuan_gerenxinxi',
      //       path: '/inventory/inventoryAction_toBatchApplyIndex.action',
      //       permission: 'taxcloud8126',
      //       id:'8126'
      //     },
      //     {
      //       label: '出入库报表',
      //       icon: 'icon-guyuan_gerenxinxi',
      //       path: '/inventory/inventoryAction_toBatchDetailReport.action',
      //       permission: 'taxcloud8128',
      //       id:'8128'
      //     },
      //   ]
      // },
      {
        label: 'menu.other011', //其他信息查询
        icon: 'm-xinxichaxun',
        permission: 'taxcloud6007',
        id:'6007',
        path: '/otherQuery',
        children: [
          {
            label: 'menu.other012', //汇率查询
            icon: 'icon-guyuan_gerenxinxi',
            path: '/statistic/statistic_toMoneyTypeHisList.action',
            permission: 'taxcloud6092',
            id:'6092'
          },
          {
            label: 'menu.other013', //查询明细
            icon: 'icon-guyuan_gerenxinxi',
            path: '/statistic/statistic_toQueryDetailSet.action',
            permission: 'taxcloud6012',
            id:'6012'
          },
          {
            label: 'menu.other014', //借还款查询
            icon: 'icon-guyuan_gerenxinxi',
            path: '/borrow/searchAction_toSearchStatusList.action',
            permission: 'taxcloud6090',
            id:'6090'
          },
          {
            label: 'menu.other015', //查询分类明细
            icon: 'icon-guyuan_gerenxinxi',
            path: '/statistic/statistic_toQueryClassify.action',
            permission: 'taxcloud6013',
            id:'6013'
          },
          {
            label: 'menu.other016', //优惠政策查询
            icon: 'icon-guyuan_gerenxinxi',
            path: '/cost/critical_toCriticalTiles.action',
            permission: 'taxcloud6093',
            id:'6093'
          }
        ]
      }
    ]
  }
];
